import type { RecommendChatCapability } from '@app/api/RecommendChat/types';
import type {
  LOYALTY_PROGRAM_SENDOUTS,
  MAX_MESSENGER,
  TELEGRAM_PERSONAL,
  YOOKASSA,
  ACQUIRING,
  ACTIVE,
  ATC_BEELINE,
  ATC_MANGO,
  AUTHORIZING,
  BANNED,
  EMAIL_HANDLER,
  ERROR,
  INSTAGRAM,
  SMS_SERVICE,
  TECH_SUPPORT,
  TELEGRAM,
  VK,
  WHATSAPP,
  INITIALIZED,
  NEW_LEAD_INTEGRATION,
} from '@app/constants';

export namespace NIntegrations {
  export type ModelSocialIntegrationOptionalProps = {
    Id: number;
    BranchId: number;
    TimeCreated: string;
    CreateUserId: number;
    CreateUser: string | null;
    SocialType: SocialType;
    OAuthUrl: string | null;
    AccountName: string | null;
    Token: string | null;
    Status: Status;
    LastStatusUpdate: string;
    ErrorMessage: string | null;
    IsDeleted: boolean;
    AccountPhoto: string | null;
    SalesFunnel: string | null;
    SalesFunnelStage: string | null;
    SocialTypeUserFriendly: string | null;
    ParseUsingNeural: boolean;
  };

  export type ModelSocialIntegration = ModelSocialIntegrationOptionalProps & {
    SocialIntegrationName: string | null;
    AccountLogin: string | null;
    Password: string | null;
    Server: string | null;
    IsSsl: boolean;
    Port: number | null;
    SalesFunnelId: number | null;
    SalesFunnelStageId: number | null;
  };

  export type SocialType = ExistedSocialType | null;

  // Хотя на 08.10.2024 в Сваггере не были описаны типы INSTAGRAM и ATC_BEELINE,
  // на деле логика фронта уже была готова принять их, поэтому они были добавлены
  export type ExistedSocialType =
    | typeof WHATSAPP
    | typeof EMAIL_HANDLER
    | typeof INSTAGRAM
    | typeof VK
    | typeof ATC_BEELINE
    | typeof ATC_MANGO
    | typeof TELEGRAM
    | typeof ACQUIRING
    | 'warehouse-1c'
    | typeof TELEGRAM_PERSONAL
    | typeof YOOKASSA
    | typeof MAX_MESSENGER
    | typeof LOYALTY_PROGRAM_SENDOUTS
    | typeof NEW_LEAD_INTEGRATION
    | typeof SMS_SERVICE
    | typeof TECH_SUPPORT;

  // Хотя на 08.10.2024 в Сваггере не был описан тип BANNED,
  // на деле логика фронта уже была готова принять его, поэтому они были добавлены
  export type Status =
    | typeof ACTIVE
    | typeof ERROR
    | typeof AUTHORIZING
    | typeof BANNED
    | typeof INITIALIZED
    | null;

  export type ModelUserIntegration = {
    Id: number;
    BranchId: number;
    BranchName: string;
    SocialType: string;
    AccountLogin: string;
    AccountName: string;
    IntegrationName: string;
    Status: string;
    IsDeleted: boolean;
    Avatar: string;
    SalesFunnel: ModelSaleFunnel;
    SalesFunnelStage: ModelSaleFunnelStage;
  };

  export type ModelSaleFunnel = {
    Id: number;
    Name: string;
    Description: string | null;
  };

  export type ModelSaleFunnelStage = {
    Id: number;
    Name: string;
    Description: string | null;
    Color: string | null;
  };

  export type ModelLeadSocialIntegration = {
    RecommendChat?: RecommendChatCapability | null;
    Id: number;
    SocialType: string | null;
    AccountLogin: string | null;
    AccountName: string | null;
    IntegrationName: string | null;
    BranchId: number;
    Branch: string | null;
    IsClientInBranch: boolean;
    Status: string;
    IsBlocked: boolean;
  };

  export type ModelAddIntegrationResponse = {
    IntegrationId: number;
    QR: string | null;
    OAuthUrl: string | null;
    InstanceToken: string | null;
  };

  export type ModelSendMessage = {
    IntegrationId: number;
    Destination: ModelDestination;
    Message: string | null;
    Attachments: ClientAttachmentDto[] | null;
    IsSendout: boolean;
  };

  export type ModelDestination = {
    Phone: string | null;
    ClientId: number;
    LeadId: number | null;
  };

  export type ClientAttachmentDto = {
    Description: string | null;
    FileName: string | null;
    FileSize: number;
    Data: string | null;
  };
}
